import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageTransition from '../components/PageTransition';
import ScrollToTop from '../components/ScrollToTop';

const MainLayout = () => {
  const location = useLocation();
  
  return (
    <div className="flex flex-col min-h-screen bg-brand-cream selection:bg-brand-olive selection:text-white overflow-x-hidden">
      <ScrollToTop />
      <Navbar />
      {/* 100px padding-top to account for the fixed navbar height */}
      <main className="flex-grow pt-[100px]">
        <PageTransition key={location.pathname}>
          <Outlet />
        </PageTransition>
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;